import { combineReducers } from 'redux';
import { data } from './data';
import { isLoading } from './is-loading';
import { sorting } from './sorting';
export const reducer = combineReducers({
    data,
    isLoading,
    sorting,
});
export default {
    data,
    isLoading,
    sorting,
};
